import { useDispatch, useState, useGlobal } from "reactn";
import { validateEmail } from "lib/forms";
import { pathOr } from "lib/functions";

export const useSignup = (
	closeModal,
	getReservation,
	blockreservation,
	handleOpenUpdateRutModal,
	openRutUpdateModal,
	handleMeet
) => {
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [showRecoveryPass, setShowRecoveryPass] = useState(false);
	const [success, setSuccess] = useState(false);
	const doSignUpWithPass = useDispatch("doSignUpWithPass");
	const [localEmail, setLocalEmail] = useState({});
	const [forms] = useGlobal("forms");
	const meta = pathOr({}, ["payload"], forms);
	const activeRutModal =
		handleOpenUpdateRutModal && handleOpenUpdateRutModal();
	const signUp = ({ email, name, password }) => {
		const userEmail = { email };
		setLocalEmail(userEmail);
		setError(null);
		if (!validateEmail(email)) {
			setError({ message: "E-mail inválido" });
			return;
		}
		if (!password) {
			setError({ message: "Password inválido" });
			return;
		}
		if (!name) {
			setError({ message: "Nombre inválido" });
			return;
		}
		setLoading(true);
		doSignUpWithPass({ email, name, password })
			.then((state) => {
				setSuccess(true);
				setLoading(false);
				closeModal();
				if (!state.user.phone || !state.user.rut) {
					if (activeRutModal) {
						return openRutUpdateModal(true);
					}
				}

				if (getReservation && blockreservation) {
					setTimeout(
						() =>
							getReservation(
								blockreservation,
								handleMeet(),
								meta
							),
						1000
					);
					return false;
				}
				if (getReservation) {
					setTimeout(() => getReservation(), 1000);
					return false;
				}
			})
			.catch((debug) => {
				if (debug.message === "EMAIL_EXISTS") {
					setShowRecoveryPass(true);
				}
				setLoading(false);
				setError({ message: "Error de autentificación", debug });
			});
	};

	return [
		signUp,
		success,
		loading,
		error,
		setShowRecoveryPass,
		showRecoveryPass,
		localEmail,
	];
};
